<template>
  <router-view></router-view>
</template>

<script lang="ts"></script>

<style scoped>
@import url('./assets/css/base.css');
#App {
  height: 100%;
}
</style>
